var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSinDividerHowItWorks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "67.75px",
    viewBox: "0 0 1200 67.75",
    enableBackground: "new 0 0 1200 67.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    fillOpacity: 0.86,
    d: "M1046.432,44.617c-37.035,10.804-71.992,21.015-143.858,21.015c-71.853,0-106.81-10.211-143.829-21.015 C719.785,33.253,679.502,21.5,600.12,21.5c-79.381,0-119.663,11.753-158.623,23.117c-37.021,10.804-71.977,21.015-143.812,21.015 c-71.82,0-106.792-10.211-143.812-21.015C114.929,33.253,74.647,21.5-4.75,21.5v59.621V80.25l0,0h1209.5l0,0V21.501 C1125.564,21.532,1085.354,33.269,1046.432,44.617z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinDividerHowItWorks);
export default __webpack_public_path__ + "static/media/sin-divider-how-it-works.2b57665c17b4c673482c8b42f617d11d.svg";
export { ForwardRef as ReactComponent };